import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import MarketApp from "./MarketApp";
import "./index.css";

const hostname = window.location.hostname.toLowerCase();
const RootApp =
  hostname === "market.wow5050.org" ? MarketApp : App;

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <RootApp />
    </BrowserRouter>
  </React.StrictMode>
);
